import {IAmplitudeExperimentVariants, initAmplitude, resolveFeatureFlags, setResolvedFeatureFlags} from "@pg-mono/amplitude";

import {amplitudeApiKey, amplitudeDeploymentKey} from "../common/app/read_rp_environment_variables";
import {rpFeatureFlags} from "../common/feature_flags/rp_feature_flags";

declare global {
    interface Window {
        __AMPLITUDE_VARIANTS__?: IAmplitudeExperimentVariants;
    }
}

export const rpAmplitudeInit = (userId?: string) => {
    const initialVariants = window.__AMPLITUDE_VARIANTS__;
    delete window.__AMPLITUDE_VARIANTS__;

    if (initialVariants) {
        setResolvedFeatureFlags(resolveFeatureFlags(rpFeatureFlags, initialVariants));
    }

    initAmplitude({
        amplitudeApiKey,
        deploymentKey: amplitudeDeploymentKey,
        initialVariants,
        userId
    });
};
